export default __webpack_public_path__ + "static/media/digital-organization.4ad447ad.svg";